import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../src/Context/AuthContext';
import { Link } from 'react-router-dom';
import EmptyHeader from '../../Components/Shared/EmptyHeader';
import AuthHeader from '../../Components/Account/AuthHeader';

const ForgotPasswordPage = ({ portalSettings }) => {
    //State Variables
    const { login, isAuthenticated } = useAuth();
    const [email, setEmail] = useState('');
    const [userName, setUserName] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    //Set Site Title
    document.title = `${companyName} - Forgot Password`;

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    const psm = portalSettings || {};

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/home');
        }
    }, [isAuthenticated, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const queryParams = new URLSearchParams({ userEmail: email, userName });
            const res = await fetch(`${apiURL}/account/forgot-password?${queryParams.toString()}`, {
                method: 'POST',
                credentials: 'include'
            });

            if (!res.ok) {
                const errorData = await res.json().catch(() => ({}));
                setError(errorData.message || 'Unable to process request.');
                return;
            }

            setSubmitted(true);
        } catch (err) {
            console.error('Forgot password error:', err);
            setError('Unable to send reset instructions. Try again later.');
        }
    };

    return (
        <div className="auth-page">
            <EmptyHeader />
            <EmptyHeader />
            <EmptyHeader />
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2 className="baseHeader">Forgot Password</h2>
                {submitted ? (
                    <p>
                        If an account exists with the provided email and username, reset instructions
                        have been sent.
                    </p>
                ) : (
                    <form className="baseForm" onSubmit={handleSubmit}>
                        <label className="baseLabel">Email</label>
                        <input
                            type="email"
                            value={email}
                            className="baseInput"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />

                        <label className="baseLabel">Username</label>
                        <input
                            type="text"
                            value={userName}
                            className="baseInput"
                            onChange={(e) => setUserName(e.target.value)}
                            required
                        />

                            {error && <p className="text-danger">{error}</p>}

                        <button className="baseButton" type="submit">Send Reset Link</button>
                    </form>
                )}
                <div className="auth-links">
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
